  import Store, { RootState } from '@/stores';
  const BASE_URL = 'https://api.heishigongye.com';
  export const getUploadConfig = () => {
    const state = Store.store.getState() as RootState;
    const tokenInfo = state.Token?.info || {};
    const accessToken = (tokenInfo as any).accessToken || '';
    const tokenType = (tokenInfo as any).tokenType || '';
    const action = `${BASE_URL}/Api/Tenant/V1/file/upload`;
    const headers = { Authorization: `${tokenType} ${accessToken}` }
    return { action, headers };
  };